import Marker, { Props } from '../../components/Map/Marker';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { toggleKitaSelection, setMapMenuVisibility } from '../../actions';
import { DOUBLE_CLICK_THRESHOLD } from '../../constants';
import { gotoKita } from '../../lib/Utils';

const markerClickState = {
    lastClick: 0,
    timer: 0
};

interface HandleSideMenuVisibility {
    showSideMenu();
}

export default compose(

    connect(
        // map state to props
        undefined,

        // map dispatch to props
        (dispatch) => {
            return {
                triggerToggleKitaSelection(id) {
                    dispatch(
                        toggleKitaSelection(id)
                    );
                },

                showSideMenu() {
                    dispatch(setMapMenuVisibility(true));
                }
            };
        }
    ),

    withHandlers({

        onClick: ({ kita, triggerToggleKitaSelection, showSideMenu }: Props & HandleSideMenuVisibility) => e => {
            const now = Date.now();
            if (markerClickState.lastClick === 0) {
                markerClickState.lastClick = now;
                markerClickState.timer = window.setTimeout(() => {
                    markerClickState.lastClick = 0;
                    showSideMenu();
                    gotoKita(kita.id, kita.slug);
                }, DOUBLE_CLICK_THRESHOLD);
            }
            else {
                if (now - markerClickState.lastClick < DOUBLE_CLICK_THRESHOLD) {
                    window.clearTimeout(markerClickState.timer);
                    markerClickState.lastClick = 0;
                    triggerToggleKitaSelection(kita.id);
                }
            }
        },

        // essence of this is to prevent the map from zooming on double click. nothing else
        onDblClick: props => e => {
            e.originalEvent.stopImmediatePropagation();
        }

    })
)(Marker);